export default __webpack_public_path__ + "static/media/logout.da804b06.svg";